import { PropsWithChildren } from 'react'

import { Form } from 'antd'

interface FieldLayoutProps extends PropsWithChildren {
  error?: string
  label?: string
  required?: boolean
}

const STYLE = {
  marginBottom: 0,
}

const FieldLayout = ({
  children,
  error,
  label,
  required,
}: PropsWithChildren<FieldLayoutProps>) => {
  return (
    <Form.Item
      label={label}
      required={required}
      validateStatus={error ? 'error' : undefined}
      help={error}
      style={STYLE}
    >
      {children}
    </Form.Item>
  )
}

export default FieldLayout
